import axios from "axios";

const mpGetPaymentInfos = async ({ paymentId }) => {
  try {
    const { data } = await axios.post(`/mercadopago/payment/infos`, {
      paymentId: paymentId,
    });

    if (!data?.success) throw new Error();

    return {
      success: true,
      message: "Sucesso ao obter informações do pagamento",
      paymentImage: data?.paymentImage,
      paymentPayload: data?.paymentPayload,
    };
  } catch (error) {
    return {
      success: false,
      message: "Erro ao obter informações do pagamento",
    };
  }
};

export { mpGetPaymentInfos };
